import { render } from "./PaperDetails.vue?vue&type=template&id=7264651a"
import script from "./PaperDetails.vue?vue&type=script&lang=js"
export * from "./PaperDetails.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./PaperDetails.vue?vue&type=style&index=1&id=7264651a&lang=scss"
script.render = render

export default script